import styled from "styled-components";
import { screenSizes } from "../../styles/theme";

export const FooterWrapper = styled.div`
  background: linear-gradient(319.67deg, #091c00 -9.22%, #121511 77.04%);
  color: #fff;
  padding: 4rem;
  @media (max-width: ${screenSizes.M}px) {
    padding: 2rem 1rem;
  }
  h2 {
    font-size: 80px;
    font-weight: 400;
    letter-spacing: -4px;
    line-height: 88px;
    @media (max-width: ${screenSizes.M}px) {
      font-size: 48px;
      line-height: 48px;
    }
  }
  i {
    font-size: 64px;
    @media (max-width: ${screenSizes.M}px) {
      font-size: 36px;
      letter-spacing: -2px;
    }
  }
  p {
    font-size: 18px;
    color: #ffffff80;
    padding-bottom: 40px;
    @media (max-width: ${screenSizes.M}px) {
      font-size: 16px;
      padding-bottom: 0px;
      margin-block: 25px;
      line-height: 24px;
    }
  }
  .footer_content_btn {
    display: flex;
    align-items: center;
    gap: 50px;
    @media (max-width: ${screenSizes.M}px) {
      flex-direction: column;
      gap: 20px;
    }
  }
  .footer_touch_btn {
    margin-right: 1rem;
    display: flex;
    justify-content: center;
    
    button {
      max-width: 200px;
      width: 200px;
      height: 200px;
      border-radius: 50%;
      font-size: 20px;
      font-weight: 700;
      border: 2px solid #FFFFFF;
      background-color: transparent;
      color: #ffffff;
      cursor: pointer;
      &:hover {
        border: 2px solid #ffffff20;
        background: #FFFFFF33;
      }
    }
  }
  .bottom_footer {
    ul {
      list-style: none;
      padding-left: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 10px;
      margin: 20px 0 0;
      border-top: 1px solid #ffffff10;
      padding-top: 20px;
      @media (max-width: ${screenSizes.M}px){
        justify-content: left;
        align-items: start;
        text-align: left;
        gap: 0px;
        margin: 0px;
        font-size: 14px;
      }
      li {
        color: #ffffff80;
        a {
          color: #fff;
          text-decoration: underline;
          &:hover {
            color: #ffffff80;
          }
        }
        span {
          margin-inline: 10px;
          @media (max-width: ${screenSizes.L}px){
            margin-inline: 5px;
          }
        }
      }
    }
    @media (min-width: ${screenSizes.M}px) {
      ul {
        flex-direction: row;
        justify-content: space-between;
        text-align: left;
      }
    }
  }
  img {
    padding: 4rem 0;
    max-width: 200px;
    margin: 0 auto;
    @media (max-width: ${screenSizes.L}px) {
      max-width: 150px;
      padding: 2rem 0;
    }
  }
  .btn_wrapper {
    display: flex;
    gap: 20px;
    @media (max-width: ${screenSizes.L}px) {
      flex-direction: column;
      gap: 0px;
    }
  }
  .redirect_btn {
    flex: 1 1 0;
    button {
      max-width: 300px;
      width: 100%;
      margin-right: 10px;
      justify-content: space-between;
      background-color: transparent;
      border: 1px solid #FFFFFF33;
      color: #ffffff;
      border-radius: 80px;
      &:hover {
        background-color: #FFFFFF33;
      }
      @media (max-width: ${screenSizes.L}px) {
        max-width: none;
        margin-bottom: 15px;
        margin-right: 0px;
      }
    }
  }
`;
export const FooterTop = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 50px 2rem;
  border-bottom: 1px solid #eaeaea;
  gap: 2rem;
  @media (max-width: ${screenSizes.M}px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  @media (max-width: ${screenSizes.S}px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }
`;
export const FooterTopMenu = styled.ul`
  padding: 0px;
  list-style: none;
  margin: 0;
  h4 {
    font-weight: 400;
    color: #1e440b;
    padding-bottom: 15px;
  }
  li {
    a {
      color: #16161a99;
      display: inline-block;
      line-height: 32px;
      font-family: "Sora", sans-serif;
    }
  }
`;
export const FooterBottom = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 30px 24px;
  span {
    font-size: 13px;
    color: #16161a99;
    font-family: "Sora", sans-serif;
  }
  a {
    font-size: 13px;
    color: #16161a99;
    font-family: "Sora", sans-serif;
  }
`;
